import { render, staticRenderFns } from "./yszc.vue?vue&type=template&id=9ce5267c&scoped=true"
import script from "./yszc.vue?vue&type=script&lang=js"
export * from "./yszc.vue?vue&type=script&lang=js"
import style0 from "./yszc.vue?vue&type=style&index=0&id=9ce5267c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce5267c",
  null
  
)

export default component.exports